module.exports = __webpack_public_path__ + "img/web2.387876a1.png";